import { AnketaQuestion } from './AnketaQuestion';

export default AnketaQuestion;